export const timeMenu = [
  {
    id: 1,
    value: "now",
    title: "На зараз",
  },
  {
    id: 2,
    value: "today",
    title: "Сьогодні",
  },
  {
    id: 3,
    value: "preOrder",
    title: "Попереднє замовлення",
  },
];

export const timeValues = {
  now: "now",
  today: "today",
  preOrder: "preOrder",
};

export const today = new Date();

export const minTime = new Date(today.getTime() + 30 * 60000);

export const maxTime = new Date(today);
maxTime.setHours(23, 59, 59, 999);

export const isToday = (date: Date | null) => {
  if (date) {
    return (
      date.getDate() === today.getDate() &&
      date.getMonth() === today.getMonth() &&
      date.getFullYear() === today.getFullYear()
    );
  }
  return false;
};

export const filterFutureTimes = (time: Date) => {
  return time.getTime() >= today.getTime();
};

const days = ["Нд", "Пн", "Вт", "Ср", "Чт", "Пт", "Сб"];

const months = [
  "Січень",
  "Лютий",
  "Березень",
  "Квітень",
  "Травень",
  "Червень",
  "Липень",
  "Серпень",
  "Вересень",
  "Жовтень",
  "Листопад",
  "Грудень",
];

export const locale = {
  localize: {
    day: (n: number) => days[n],
    month: (n: number) => months[n],
    ordinalNumber: (n: number) => `${n}-й`,
    era: (n: number) => (n === 1 ? "н.е." : "до н.е."),
    quarter: (n: number) => `${n}-й квартал`,
    dayPeriod: (n: string) => (n === "am" ? "ранок" : "вечір"),
  },
  formatLong: {
    date: () => "dd/MM/yyyy",
    time: () => "HH:mm",
    dateTime: () => "dd/MM/yyyy HH:mm",
  },
  match: {
    ordinalNumber: () => null,
    era: () => null,
    quarter: () => null,
    month: () => null,
    day: () => null,
    dayPeriod: () => null,
  },
};
